export enum HomeCard {
  Pumps = 1,
  Fields,
  Pivots,
  Sensors,
  PumpWeather
}
